module.exports = __webpack_public_path__ + "0c0ace8a7f06ffcd8706bd052b97cc04.svg";